import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";

// Layout
import Layout from "./components/layout/Layout";
import AdminLayout from "./components/layout/AdminLayout";

// Public Pages
import Home from "./pages/Home";
import Leistungen from "./pages/Leistungen";
import Wertermittlung from "./pages/services/Wertermittlung";
import Verkauf from "./pages/services/Verkauf";
import Vermietung from "./pages/services/Vermietung";
import Vermittlung from "./pages/services/Vermittlung";
import Immobilien from "./pages/Immobilien";
import ImmobilienDetail from "./pages/ImmobilienDetail";
import Referenzen from "./pages/Referenzen";
import UeberUns from "./pages/UeberUns";
import Kontakt from "./pages/Kontakt";
import FAQ from "./pages/FAQ";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import AGB from "./pages/AGB";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProperties from "./pages/admin/AdminProperties";
import AdminReferences from "./pages/admin/AdminReferences";
import AdminLeads from "./pages/admin/AdminLeads";

// Cookie Banner
import CookieBanner from "./components/CookieBanner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="leistungen" element={<Leistungen />} />
            <Route path="leistungen/wertermittlung" element={<Wertermittlung />} />
            <Route path="leistungen/verkauf" element={<Verkauf />} />
            <Route path="leistungen/vermietung" element={<Vermietung />} />
            <Route path="leistungen/vermittlung" element={<Vermittlung />} />
            <Route path="immobilien" element={<Immobilien />} />
            <Route path="immobilien/:id" element={<ImmobilienDetail />} />
            <Route path="referenzen" element={<Referenzen />} />
            <Route path="ueber-uns" element={<UeberUns />} />
            <Route path="kontakt" element={<Kontakt />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="impressum" element={<Impressum />} />
            <Route path="datenschutz" element={<Datenschutz />} />
            <Route path="agb" element={<AGB />} />
          </Route>

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="properties" element={<AdminProperties />} />
            <Route path="references" element={<AdminReferences />} />
            <Route path="leads" element={<AdminLeads />} />
          </Route>
        </Routes>
        <CookieBanner />
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
